import * as Sentry from '@sentry/vue'
import { browserTracingIntegration, captureConsoleIntegration } from '@sentry/vue'
import type { App, Plugin } from 'vue'
import { Router } from 'vue-router'

const sentryPlugin: Plugin = {
  install(app: App, options: { router: Router }) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      tunnel: import.meta.env.VITE_SENTRY_TUNNEL,
      integrations: [
        browserTracingIntegration({ router: options.router }),
        captureConsoleIntegration({
          levels: [ 'error' ],
          handled: !(import.meta.env.VITE_ENV === 'development'), 
        }), 
      ], // check if handled needs to be true or false in dev
      tracePropagationTargets: [
        'localhost',
        'admin.swipe4work.com',
        'admin.test.swipe4work.com',
        /^\//,
      ],
      attachStacktrace: true,
      tracesSampleRate: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE,
      environment: import.meta.env.VITE_ENV,
    })
  },
}

export default sentryPlugin
